/**
 * 표 정렬용 숫자 비교. 오름차순 기준이고, 빈 값은 항상 뒤에 둔다.
 *
 * c6 `TableRow.compare` 의 기본 구현은 **셀 문자열**을 비교한다. "1,200" 과 "900" 을 글자로
 * 비교하면 앞자리만 보므로 900 이 뒤로 간다. 그래서 숫자 열은 행 모델이 원시값을 따로 가지고
 * 이 함수로 비교한다. 내림차순은 DataTable 이 부호를 뒤집는다(c6 기본 비교와 같은 계약).
 */
export function compareNumericNullLast(a: number | null, b: number | null): number {
  if (a === null && b === null) {
    return 0;
  }
  if (a === null) {
    return 1;
  }
  if (b === null) {
    return -1;
  }
  return a - b;
}
